(function () {
  function pad(value) {
    return String(value).padStart(2, '0');
  }

  function getCountdownTarget() {
    var now = new Date();
    var target = new Date(
      now.getFullYear(),
      now.getMonth(),
      now.getDate(),
      23,
      59,
      59,
      999
    );

    if (now.getTime() > target.getTime()) {
      target.setDate(target.getDate() + 1);
    }

    return target;
  }

  function updateCountdown(root) {
    var hoursEl = root.querySelector('[data-countdown-hours]');
    var minutesEl = root.querySelector('[data-countdown-minutes]');
    var secondsEl = root.querySelector('[data-countdown-seconds]');

    if (!hoursEl || !minutesEl || !secondsEl) {
      return;
    }

    var remainingMs = Math.max(0, getCountdownTarget().getTime() - Date.now());
    var totalSeconds = Math.floor(remainingMs / 1000);
    var hours = Math.floor(totalSeconds / 3600);
    var minutes = Math.floor((totalSeconds % 3600) / 60);
    var seconds = totalSeconds % 60;

    hoursEl.textContent = pad(hours);
    minutesEl.textContent = pad(minutes);
    secondsEl.textContent = pad(seconds);
  }

  function initCountdown(root) {
    if (root.dataset.countdownReady === 'true') {
      return;
    }

    root.dataset.countdownReady = 'true';
    updateCountdown(root);
    window.setInterval(function () {
      updateCountdown(root);
    }, 1000);
  }

  function init() {
    document.querySelectorAll('[data-bdl-collection-sale-countdown]').forEach(initCountdown);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
